import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppContext } from '../../../context/ContextApi';
import './rdv.css'
import { Link, } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiOutlineCheck } from "react-icons/ai";
import {IoIosArrowForward} from "react-icons/io";


const RdvForm = () =>
{
    const { rdvNextStep, rdv, setRdv } = useContext(AppContext)

    const handleInputChange = (event) =>
    {
        const { name, value } = event.target;
        setRdv((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        var today = new Date().toISOString().split('T')[0];
        document.getElementsByName("rdvDate")[0].setAttribute('min', today);

        function isWeekend(dateString) {
            var date = new Date(dateString);
            return date.getDay() === 0 || date.getDay() === 6;
        }

        document.getElementById("rdvDate").addEventListener("input", function() {
            if (isWeekend(this.value)) {
                alert("Désolé, nos agences sont fermées les samedis et dimanches. Veuillez choisir une jour ouvrable.");
                this.value = "";
            }
        });
    }, []);

    const heureMin = "08:00";
    const heureMax = "17:00";

    function selectTime(event) {
        const nouvelleHeure = event.target.value;

        if (nouvelleHeure < heureMin || nouvelleHeure > heureMax) {
            alert("Désolé, nos agences sont fermées à cette heure. Veuillez choisir une heure comprise entre 08H et 17H.");
            event.target.value = "";
        }

        const { name, value } = event.target;
        setRdv((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleSubmit = (event) =>
    {
        event.preventDefault();
        if(!rdv.rdvNom || !rdv.rdvPrenom || !rdv.rdvMotif || !rdv.rdvDate || !rdv.rdvHeure || !rdv.rdvTelephone ){
            toast.error("Veuillez remplir tous les  champs.", {
                position: "top-center",
                autoClose: 1000000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        }else{
            rdvNextStep(rdv);
        }

    };
    return (
        <div className="py-3 login-container-mobile">
            <h4 className="mb-3" style={{color: '#c88025'}}>Remplissez le formulaire suivant pour prendre rdv avec un Gestionnaire Clientèle.</h4>
            <div className="row flex cutom-box">
                <div className="col-md-6 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2"
                           htmlFor="rdvNom">NOM <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input
                        className="appearance-none border-input inner-box-input font-mono w-full p-2"
                        id="rdvNom" type="text"
                        name="rdvNom" value={rdv.rdvNom} onChange={handleInputChange} placeholder="Votre Nom" required/>
                </div>
                <div className="col-md-6 p-2 custom-with">
                    <label className="block fw-bold text-start leading-3 mb-2"
                           htmlFor="rdvPrenom">PRENOMS <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input
                        className="appearance-none border-input inner-box-input  font-mono w-full  p-2"
                        id="rdvPrenom" type="text"
                        name="rdvPrenom" value={rdv.rdvPrenom} onChange={handleInputChange} placeholder="Votre Prenoms"
                        required/>
                </div>
                <div className="col-md-6 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2" htmlFor="rdvResidence">LIEU
                        DE RESIDENCE <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input
                        className="appearance-none border-input inner-box-input  font-mono w-full  p-2"
                        id="rdvResidence" type="text"
                        name="rdvResidence" value={rdv.rdvResidence} onChange={handleInputChange}
                        placeholder="Lieu de résidence...." required/>
                </div>
                <div className="col-md-6 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2" htmlFor="rdvTelephone">NUMERO
                        DE TELEPHONE <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input
                        className="appearance-none border-input inner-box-input  font-mono w-full p-2"
                        id="rdvTelephone" type="phone"
                        name="rdvTelephone" value={rdv.rdvTelephone} onChange={handleInputChange}
                        placeholder="Votre Numero de Telephone" required/>
                </div>
                <div className="col-6 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2"
                           htmlFor="rdvDate">DATE <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input
                        className="appearance-none border-input inner-box-input font-mono w-full p-2"
                        id="rdvDate" type="date" name="rdvDate" value={rdv.rdvDate} onChange={handleInputChange}
                        placeholder="Quelle est votre disponibilité?" required/>
                </div>
                <div className="col-6 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2"
                           htmlFor="rdvHeure">HEURE <strong style={{color: '#cc992d'}}>*</strong></label>
                    <input className="appearance-none border-input inner-box-input w-full p-2"
                        id="rdvHeure" type="time" min="08:00" max="17:00" required
                        name="rdvHeure" value={rdv.rdvHeure} onChange={selectTime} placeholder="l'heure...."/>
                </div>
                <div className="col-12 p-2 custom-with">
                    <label className="block text-start fw-bold leading-3 mb-2" htmlFor="rdvMotif">MOTIF
                        DE DEMANDE <strong style={{color: '#cc992d'}}>*</strong></label>
                    <textarea className="appearance-none border-input inner-box-input font-mono w-full p-2"
                        name='rdvMotif' id="rdvMotif"
                        value={rdv.rdvMotif} onChange={handleInputChange} placeholder="VOTRE MOTIF DE DEMANDE"
                        required/>
                </div>
            </div>
            <div className="flex justify-center mt-3">
                <div className="flex justify-center align-center info-sous-btn">
                    <button onClick={(e) => handleSubmit(e)}
                            className="d-flex justify-center items-center btn bts-sm btn-warning mx-2 rounded-pill">
                        Continuer <IoIosArrowForward className="ml-2"/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default RdvForm